import React from 'react'

import SimpleVideoPlayer from '../../components/arhiveComponents/SimpleVideoPlayer'
import MediaModal from '../../components/videoComponents/MediaModal';

import './css/Media.css'

import callApi from '../../utils/callApi';
import { ANCHOR_LIST } from '../../constants/apiUrls/apiUrls';

import nudeProgramPreview from '../../assets/mediaPage/nude_program_preview_20180508-3.jpg'
import program1 from '../../assets/mediaPage/program-4-34de538648b1c0f9bd1a7c4da2aeb943.png';
import program2 from '../../assets/mediaPage/program-3-6164bc37218116c869d80bc4102fcf97.png';
import program3 from '../../assets/mediaPage/program-2-be0c065dbcfa2599ecc1a45ef4e60a80.png';
import program4 from '../../assets/mediaPage/program-1-ff9e35a7a88d10e1d2c95d0f7ce2db4a.png';
import costaRicaThumb from '../../assets/mediaPage/travel/costa_rica.png';
import hedonism2Thumb from '../../assets/mediaPage/travel/hedo,_jamaica.png';
import tulumThumb from '../../assets/mediaPage/travel/mexico.png';
import miamiBeachThumb from '../../assets/mediaPage/travel/miami_beach_Florida.png';
import torontoFestThumb from '../../assets/mediaPage/travel/TIFF_Toronto.png';
import amstelThumb from '../../assets/mediaPage/travel/netherlands.png';
import timesSqareThumb from '../../assets/mediaPage/travel/new_york.png';
import bratislavaThumb from '../../assets/mediaPage/travel/slovakia.png';
import palmSpringsThumb from '../../assets/mediaPage/travel/Palm_Springs_California.png';
import alaskaThumb from '../../assets/mediaPage/travel/split,_alaksa.png';
import puertoVallartaThumb from '../../assets/mediaPage/travel/puerto_vallarta_Mexico.png';
import rivieraMayaThumb from '../../assets/mediaPage/travel/Riviera_Maya_Resort_Mexico.png';
import bobbieBrownThumb from '../../assets/mediaPage/meetings/BOBBIE_BROWN.png';
import kateQuiglieyThumb from '../../assets/mediaPage/meetings/comedian_kate_quigley.png';
import hollyRandalThumb from '../../assets/mediaPage/meetings/holly_randall.png';
import tahliaParisThumb from '../../assets/mediaPage/meetings/tahlia_paris-2.png';
import kenzieReevesThumb from '../../assets/mediaPage/meetings/kenzie_reeves.png';
import romiRainThumb from '../../assets/mediaPage/meetings/romi_rain.png';
import reyaSunshineThumb from '../../assets/mediaPage/meetings/reya_sunshine.png';
import kristenScottThumb from '../../assets/mediaPage/meetings/Kristen_Scott.png';
import Alana from '../../assets/mediaPage/anchors/Alana.jpg';
import Eila from '../../assets/mediaPage/anchors/Eila.jpg';
import Frankie from '../../assets/mediaPage/anchors/Frankie.jpg';
import Isabella from '../../assets/mediaPage/anchors/Isabella.jpg';
import Laura from '../../assets/mediaPage/anchors/Laura.jpg';
import Louise from '../../assets/mediaPage/anchors/Louise.jpg';
import Madison from '../../assets/mediaPage/anchors/Madison.jpg';
import Marina from '../../assets/mediaPage/anchors/Marina.jpg';
import Shannon from '../../assets/mediaPage/anchors/Shannon.jpg';
import Tia from '../../assets/mediaPage/anchors/Tia.jpg';
import Whitney from '../../assets/mediaPage/anchors/Whitney.jpg';

const videoElement = {
  imageUrl: nudeProgramPreview,
  clipUrl: 'https://nnprod.objects.mojocloud.com/guest/tour_videos/NNTOUR_AUG_2019_1080.mp4'
};

class MediaPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            video: {},
            anchorList: []
        }
    }

    componentDidMount() {
        document.title = "Media | Naked News"
        this.fetchAnchorList();
    }

    closeMediaModal = () => {
        this.setState({showModal: false})
    }

    fetchAnchorList = () => {
        callApi(ANCHOR_LIST, 'GET', {})
            .then(response => {
                this.setState({ anchorList: response.data.currentAnchors});
            })
            .catch(err => console.error(err));
    }

    generateUrl = (name, id) => {
        const anchorName = this.generateName(name);
        return `naked-news-anchor-${anchorName}-a${id}`;
    }

    generateName = (name) => {
        return name.toLowerCase().split(' ').join('-');
    }

    showMediaModal = e => {
        const { dataset } = e.target;
        this.setState({
            showModal: true,
            video: {
                imageUrl: dataset.img,
                clipUrl: dataset.video
            }
        })
    }

    getProperImageUrl = (name, currentUrl) => {
        const firstName = name.split(' ')[0];
        let url = '';
        switch (firstName) {
            case 'Alana':
                url = Alana;
                break;
            case 'Eila':
                url = Eila;
                break;
            case 'Frankie':
                url = Frankie;
                break;
            case 'Isabella':
                url = Isabella;
                break;
            case 'Laura':
                url = Laura;
                break;
            case 'Louise':
                url = Louise;
                break;
            case 'Madison':
                url = Madison;
                break;
            case 'Marina':
                url = Marina;
                break;
            case 'Shannon':
                url = Shannon;
                break;
            case 'Tia':
                url = Tia;
                break;
            case 'Whitney':
                url = Whitney;
                break;
            default:
                url = currentUrl;
        }
        return url;
    }

    render() {
        const { anchorList } = this.state;
        return (
          <div id="application">
              <div className="media-page">
                  <section className="container about">
                      <h1 className="h2">Who we are</h1>
                      <SimpleVideoPlayer audition={videoElement} />
                      <p>Naked News is the only program of its kind on the planet. Real news, sports, entertainment – our gorgeous team of anchors cover it all in brilliant HD! Plus, our weekly auditions and sexy guests mean there's always fresh faces stopping by! When we're not covering the latest in news and pop culture, we're out on location at sinful destinations like Hedonism Jamaica and Las Vegas! &nbsp;Ever wonder what a naked cannonball or go-karting race looks like? See for yourself when our anchors go toe-to-toe in Versus! And we're always trying out new things – from rage rooms to BDSM – in Pop My Cherry! Naked News produces six new episodes a week, and can be streamed on your computer, smartphone or tablet. Members get access to thousands of past episodes in our archives.</p>
                      <p>For nearly two decades Naked News has been the one and only program with nothing to hide!</p>
                  </section>
                  <section className="anchors container">
                      <div className="h2">Our Anchors</div>
                      <div className="row-r thumbs">
                          {
                              anchorList.map((anchor, id) => {
                                  return (
                                    <div className="col-md-3 col-sm-4 col-xs-6" key={anchor.name+id}>
                                        <a className="anchor-bio" href={this.generateUrl(anchor.name, anchor.id)}>
                                            <img className="img-responsive" src={this.getProperImageUrl(anchor.name, anchor.image)} alt="Current Anchor" />
                                            <span className="caption">
                                            <span className="h3">{anchor.name}</span>
                                            <strong style={{display: 'block'}}>Bio</strong>
                                            </span>
                                        </a>
                                    </div>
                                  )
                              })
                          }
                      </div>
                  </section>
                  {this.state.showModal &&
                    <MediaModal
                      audition={this.state.video}
                      closeMediaModal={this.closeMediaModal}
                    />
                  }
                  <section className="places container">
                      <div className="h2">Where we've been</div>
                      <div className="row-r thumbs">
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={costaRicaThumb} alt="costa rica" data-img={costaRicaThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_1-Costa-Rica-2020-12-29.mp4" onClick={this.showMediaModal} />
                                  <div className="caption"><strong>Costa Rica</strong>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={hedonism2Thumb} alt="hedonism 2" data-img={hedonism2Thumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_2-Hedonism-Jamaica-2019-12-08.mp4" onClick={this.showMediaModal} />
                                  <div className="caption"><strong>Hedonism II</strong>, Jamaica
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                                <div className="video-modal" href="#"><img src={tulumThumb} alt="tulum" data-img={tulumThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_3-Tulum-Mexico-2020-03-29.mp4" onClick={this.showMediaModal} />
                                  <div className="caption"><strong>Tulum</strong>, Mexico
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={miamiBeachThumb} alt="miami beach" data-img={miamiBeachThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_4-Miami-Beach-2018-06-20.mp4" onClick={this.showMediaModal} />
                                  <div className="caption"><strong>Miami Beach</strong>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={torontoFestThumb} alt="toronto film festival" data-img={torontoFestThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_5-TIFF-2019-09-15.mp4" onClick={this.showMediaModal} />
                                  <div className="caption"><strong>Toronto International Film Festival</strong>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={amstelThumb} alt="amstel river" data-img={amstelThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_6-Amstel-River-2019-06-02.mp4" onClick={this.showMediaModal} />
                                  <div className="caption"><strong>Amstel River</strong>, Holland
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={timesSqareThumb} alt="times sqare" data-img={timesSqareThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media-7-Times-Square-2019-11-05.mp4" onClick={this.showMediaModal} />
                                  <div className="caption"><strong>Times Sqare</strong>, New York
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={bratislavaThumb} alt="bratislava" data-img={bratislavaThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media-8-Bratisalva-2019-10-13.mp4" onClick={this.showMediaModal} />
                                  <div className="caption"><strong>Bratislava</strong>, Slovakia
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={palmSpringsThumb} alt="terra cotta resort" data-img={palmSpringsThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_9-Palm-Springs-2020-09-02.mp4" onClick={this.showMediaModal} />
                                  <div className="caption"><strong>Terra Cotta Resort &amp; Spa</strong>, Palm Springs
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={alaskaThumb} alt="alaska" data-img={alaskaThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_10-Alaska-2019-12-27.mp4" onClick={this.showMediaModal} />
                                  <div className="caption"><strong>Alaska</strong>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={puertoVallartaThumb} alt="puerto vallarta" data-img={puertoVallartaThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_11-Puerto-Vallarto-2018-03-18.mp4" onClick={this.showMediaModal} />
                                  <div className="caption"><strong>Puerto Vallarta</strong>, Mexico
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={rivieraMayaThumb} alt="desire resort" data-img={rivieraMayaThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_12-Desire-Resort-2018-03-25.mp4" onClick={this.showMediaModal} />
                                  <div className="caption"><strong>Desire Resort</strong>, Riviera Maya
                                  </div>
                              </div>
                          </div>
                      </div>
                  </section>
                  <section className="celebs container">
                      <div className="h2">Who we've met</div>
                      <div className="row-r thumbs">
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={bobbieBrownThumb} alt="bobbie brown" data-img={bobbieBrownThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_1-Bobbi-Brown-2020-01-12.mp4" onClick={this.showMediaModal} />
                                  <div className="caption">
                                      <div className="name">Bobbie Brown</div>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={kateQuiglieyThumb} alt="Kate Quigliey" data-img={kateQuiglieyThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_2-Kate-Quigley-2019-09-08.mp4" onClick={this.showMediaModal} />
                                  <div className="caption">
                                      <div className="name">Kate Quigliey</div>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={hollyRandalThumb} alt="Holly Randall" data-img={hollyRandalThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_3-Holly-Randall-2019-08-25.mp4" onClick={this.showMediaModal} />
                                  <div className="caption">
                                      <div className="name">Holly Randall</div>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={tahliaParisThumb} alt="Tahlia Paris" data-img={tahliaParisThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media-4-Thalia-Paris-2021-01-28.mp4" onClick={this.showMediaModal} />
                                  <div className="caption">
                                      <div className="name">Tahlia Paris</div>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={kenzieReevesThumb} alt="Kenzie Reeves" data-img={kenzieReevesThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_5-Kenzie-Reeves-2020-05-31.mp4" onClick={this.showMediaModal} />
                                  <div className="caption">
                                      <div className="name">Kenzie Reeves</div>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={romiRainThumb} alt="Romi Rain" data-img={romiRainThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_6-Romi-Rain-2020-04-26.mp4" onClick={this.showMediaModal} />
                                  <div className="caption">
                                      <div className="name">Romi Rain</div>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={reyaSunshineThumb} alt="Reya Sunshine" data-img={reyaSunshineThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media_7-Reya-Sunshine-2020-09-07.mp4" onClick={this.showMediaModal} />
                                  <div className="caption">
                                      <div className="name">Reya Sunshine</div>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-3 col-sm-4 col-xs-6">
                              <div className="video-modal" href="#"><img src={kristenScottThumb} alt="Kristen Scott" data-img={kristenScottThumb} data-video="https://nnvideos.static.mojocloud.com/guest/media/2021/NN_Media-8-Kristen-Scott-2019-05-19.mp4" onClick={this.showMediaModal} />
                                  <div className="caption">
                                      <div className="name">Kristen Scott</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </section>
                  <section className="programming container">
                      <div className="h2">Our Programming</div>
                      <div className="programming-table">
                          <div className="program">
                              <img src={program1} alt="Program 1" />
                              <div className="program-info">
                                  <header>
                                      <div className="number h3">1:</div>
                                      <hgroup>
                                          <div className="h3">Daily Internet Program</div>
                                          <div className="h4">(Monday to Friday, approx 22 minutes each)</div>
                                      </hgroup>
                                  </header>
                                  <div className="contents">
                                      <p>Each episode covers all the important topics of the day! In addition to our daily news bulletins, we cover sports, entertainment, trending on-line, weather, music and everything else that's happening in popular culture! Each episode is approximately 22 minutes long and just as our title implies, all the stories are presented by beautiful naked women!'
                                      </p>
                                  </div>
                              </div>
                          </div>
                          <div className="program">
                              <img src={program2} alt="Program 2" />
                              <div className="program-info">
                                  <header>
                                      <div className="number h3">2:</div>
                                      <hgroup>
                                          <div className="h3">Weekly Magazine Progam</div>
                                          <div className="h4">(Sunday, approx 22 minutes)</div>
                                      </hgroup>
                                  </header>
                                  <div className="contents">
                                      <p>Our Sunday Naked News Magazine is an entertainment focused program where we highlight many of our sexy location shoots. These include 2 of our most popular segments, naked news travels and naked in the streets. Our anchors also get personal, answering audience questions in segments like Viewer s Mail. We also have all kinds of lifestyle features including Cooking in the Raw and our fitness segment, Flex Appeal.
                                      </p>
                                  </div>
                              </div>
                          </div>
                          <div className="program">
                              <img src={program3} alt="Program 3" />
                              <div className="program-info">
                                  <header>
                                      <div className="number h3">3:</div>
                                      <hgroup>
                                          <div className="h3">Naked News TV</div>
                                          <div className="h4">(television only, approx 45 minutes)</div>
                                      </hgroup>
                                  </header>
                                  <div className="contents">
                                      <p>This weekly edition of Naked News is for TV only and combines our Friday and Sunday internet programs into a 45 minute naked news super-show. This is where we serve up the very best of naked news including exotic location shoots, celebrity interviews, auditions, movie reviews and much much more.
                                      </p>
                                  </div>
                              </div>
                          </div>
                          <div className="program">
                              <img src={program4} alt="Program 4" />
                              <div className="program-info">
                                  <header>
                                      <div className="number h3">4:</div>
                                      <hgroup>
                                          <div className="h3">NN Uncovered</div>
                                          <div className="h4">(8 episode docu-series)</div>
                                      </hgroup>
                                  </header>
                                  <div className="contents">
                                      <p>This 8 part docu-series gives you unprecedented access behind the scenes at Naked News. Get to know our on-air hosts and meet the wacky off-camera employers who help make the one and only program with nothing to hide. Naked News Uncovered is funny, gripping, and totally uncensored!
                                      </p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </section>
              </div>

          </div>
        );
    }
}

export default MediaPage;